import React from 'react';
import getImageRequestName from '../../../../../images';
import { generateLink } from '../../../../../lib/helpers';
import { sanitizePrice } from '../../../../../lib/price';
import SchemaTag from '../../../../../lib/SchemaTag';


function MetaStock() {
  let inStock;
  if (inStock === '-1') {
    return 'OutOfStock';
  }
  if (inStock === '100') {
    return 'Discontinued';
  }
  return 'InStock';
}

function getImageUrlIfAny(imageSingle, imagePlural) {
  let img = imageSingle;
  if (!img && imagePlural) {
    img = imagePlural;
  } else if (!img) {
    return '';
  }
  const url = getImageRequestName(img);
  return `"image": ${JSON.stringify(url)},`;
}

const RenderSchemaTag = ({
  name,
  varenr,
  price,
  imageSingle,
  imagePlural,
  url,
}) => (
  <SchemaTag>
    {/* Husk på ikke at lave komma efter det sidste element i et objekt  */}
    {`
        {
          "@context": "https://schema.org",
          "@type": "Product",
          ${getImageUrlIfAny(imageSingle, imagePlural)}
          "name": ${JSON.stringify(name)},
          "sku": ${JSON.stringify(varenr)},
          "offers": {
              "@type": "Offer",
              "availability": ${JSON.stringify(MetaStock())},
              "price": ${JSON.stringify(sanitizePrice(price) / 100)},
              "priceCurrency": "DKK",
              "url": ${JSON.stringify(generateLink(url))}
          }
        }
      `}
  </SchemaTag>
);

export default RenderSchemaTag;
